<template>
  <div class="bg-white rounded-sm m-2">
    <b-row>
      <b-modal title="Application Details" ref="applicationDetails" size="xl" hide-footer>
        <CopyrightAmendmentDetails :tracking-number="trackingNumber"/>
      </b-modal>
    </b-row>
    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
          <span class="title">CopyrightAmendment Applications</span>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="flex mx-3 mt-3">
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="pre-waiting">
          <span v-if="getCopyrightAmendmentStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto" >{{getCopyrightAmendmentStatistics.draft.toLocaleString()}}</span>
        </div>
        <div class="pre-waiting">
          <span class="text-sm mx-auto">Drafts</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="waiting">
          <span v-if="getCopyrightAmendmentStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto" >{{getCopyrightAmendmentStatistics.pending.toLocaleString()}}</span>
        </div>
        <div class="waiting">
          <span class="text-sm mx-auto">In Queue</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="normal">
          <span v-if="getCopyrightAmendmentStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAmendmentStatistics.assigned.toLocaleString()}}</span>
        </div>
        <div class="normal">
          <span class="text-sm mx-auto">Assigned</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="off-normal">
          <span v-if="getCopyrightAmendmentStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAmendmentStatistics.escalated.toLocaleString()}}</span>
        </div>
        <div class="off-normal">
          <span class="text-sm mx-auto">Escalated</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="warning">
          <span v-if="getCopyrightAmendmentStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAmendmentStatistics.queried.toLocaleString()}}</span>
        </div>
        <div class="warning">
          <span class="text-sm mx-auto">Queried</span>
        </div>
      </div>

      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="positive">
          <span v-if="getCopyrightAmendmentStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAmendmentStatistics.approved.toLocaleString()}}</span>
        </div>
        <div class="positive">
          <span class="text-sm mx-auto">Approved</span>
        </div>
      </div>
      <div class="flex-initial p-3 mx-2 stat-count shadow bg-white rounded-md" >
        <div class="all">
          <span v-if="getCopyrightAmendmentStatistics === null" class="h3 mx-auto" >0</span>
          <span v-else class="h3 mx-auto">{{getCopyrightAmendmentStatistics.total.toLocaleString()}}</span>
        </div>
        <div class="all">
          <span class="text-sm mx-auto">Total</span>
        </div>
      </div>
    </b-row>
    <b-row class="flex">
      <b-col cols="12">
        <b-row class="pt-3">
          <b-col>
            <AllCopyrightAmendmentSubmissions @openDetails="openDetails" />
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AllCopyrightAmendmentSubmissions from "@/views/home/services/copyright-amendment/submissions/AllCopyrightAmendmentSubmissions.vue";
import CopyrightAmendmentDetails from "@/views/home/services/copyright-amendment/submissions/CopyrightAmendmentDetails.vue";

export default {
  name: "CopyrightAmendmentApplications",
  components: {
    CopyrightAmendmentDetails,
    AllCopyrightAmendmentSubmissions,
  },
  data(){
    return{
      currentRoute: "pending",
      trackingNumber:null,
    }
  },
  mounted(){
    this.fetchCopyrightAmendmentStatistics()
  },
  methods:{
    ...mapActions(["fetchCopyrightAmendmentStatistics"]),
    select(route){
      this.currentRoute = route
    },
    openDetails(trackingNumber){
      this.trackingNumber = trackingNumber
      this.$refs.applicationDetails.show()
    }
  },
  computed:{
    ...mapGetters(["getCopyrightAmendmentStatistics"])
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/menu.css";

.pre-waiting{
  @apply flex text-gray_title;
}

.off-normal{
  @apply flex text-blue-light;
}

.waiting{
  @apply flex text-gray;
}

.normal{
  @apply flex text-blue;
}

.positive{
  @apply flex text-green;
}

.warning{
  @apply flex text-orange;
}

.all{
  @apply flex text-flopurple;
}

.stat-count{
  display: inline;
  width: 12%;
  @apply my-1;
}
</style>
